import React from 'react';
import { StyledButton } from '../../../../../../../common/Styleguide/Common/Button';
import { ApolloError } from '@apollo/client';
import { SubmissionContext } from '../../Context/SubmissionProvider';
import { canDeveloperDeleteGame } from '@crazygames/game-types/src/utils/canDeveloperDeleteGame';
import { DeleteState, SubmissionDeleteDialog } from './SubmissionDeleteDialog';

const SubmissionDeleteButton = () => {
  const { submission } = React.useContext(SubmissionContext);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [deleteState, setDeleteState] = React.useState<DeleteState>('not-started');
  const [apolloError, setApolloError] = React.useState<ApolloError | undefined>(undefined);

  if (!submission) {
    return null;
  }

  const cannotBeDeleted = !canDeveloperDeleteGame(submission.status, submission.gameStatus);

  if (cannotBeDeleted) {
    return null;
  }

  const onDeleteClick = () => {
    if (deleteState !== 'not-started') {
      return;
    }
    setApolloError(undefined);
    setShowConfirmDialog(true);
  };

  return (
    <>
      <StyledButton
        sx={{
          borderRadius: '8px',
          width: '100%',
        }}
        variant="contained"
        onClick={onDeleteClick}
        color="red"
      >
        Remove game
      </StyledButton>
      <SubmissionDeleteDialog
        id={submission.id}
        showConfirmDialog={showConfirmDialog}
        setShowConfirmDialog={setShowConfirmDialog}
        deleteState={deleteState}
        apolloError={apolloError}
        setApolloError={setApolloError}
        setDeleteState={setDeleteState}
      />
    </>
  );
};

export default SubmissionDeleteButton;
